<template>
  <v-layout align-center justify-center>
    <div class="wrapper">
      <v-card class="elevation-12">
        <v-toolbar color="color.base1" dark>
          <v-toolbar-title>ログインフォーム</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              v-model="email"
              @keyup.enter="login"
              prepend-icon="person"
              name="email"
              label="メールアドレス"
              color="color.base1"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="password"
              @keyup.enter="login"
              prepend-icon="lock"
              name="password"
              label="パスワード"
              color="color.base1"
              type="password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <!-- <div class="error-message" v-if='message'>{{message}}</div> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-on:click.prevent="login()" dark color="color.base1"
            >ログイン</v-btn
          >
        </v-card-actions>
      </v-card>
      <div class="notation">
        パスワードをお忘れの方は
        <router-link :to="{ name: 'inputEmailToResetPassword' }"
          >こちら</router-link
        >
        <br />お問い合わせは
        <a
          href="http://www.geologic.co.jp/inquiry/cs"
          target="_blank"
          rel="noopener"
          >こちら</a
        >
      </div>
      <div class="notation grey--text mt-4">
        推奨ブラウザ：Google
        Chrome（他のブラウザでご利用の場合、正常にご利用いただけません）
      </div>
    </div>
  </v-layout>
</template>

<script>
import uaParser from 'ua-parser-js'
import { setToolBarTypeLogin } from '@/mixins/setToolBarTypeLogin'

import {
  actions as drawerActions,
  drawerType,
} from '@/vuex/modules/ui/drawer/constants'
import {
  actions as snackbarActions,
  snackbarType,
} from '@/vuex/modules/ui/snackbar/constants'
import { actions as colorThemeActions } from '@/vuex/modules/ui/colorTheme/constants'

export default {
  name: 'Login',
  mixins: [setToolBarTypeLogin],
  data() {
    return {
      email: '',
      password: '',
    }
  },
  computed: {
    color() {
      return this.$store.getters['colorTheme/color']
    },
  },
  beforeCreate() {
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY, {
      flag: false,
    })
  },
  created() {
    this.$store.dispatch(colorThemeActions.INITIALIZE)
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TYPE, drawerType.NULL)
    this.$store.dispatch('drawerUriAuths/RESET')
    this.$store.dispatch(snackbarActions.CLOSE_SNACKBAR)
  },
  methods: {
    async confirmBrowser() {
      const ua = uaParser()
      if (ua.browser.name !== 'Chrome') {
        const confirmed = await this.$confirm(
          'こちらの環境は推奨環境ではありません',
          {
            body: 'Google Chrome をダウンロードしてください。',
            cancelText: 'Google Chrome のダウンロードページへ移動する',
          },
        )
        if (!confirmed) {
          window.open('https://www.google.com/intl/ja_jp/chrome/')
        }
      }
    },
    async login() {
      const params = {
        email: this.email,
        password: this.password,
        cb: this.confirmBrowser,
      }
      try {
        await this.$store.dispatch('loginAuth/LOGIN', params)
        const message = 'ログインしました'
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.SUCCESS,
          message,
        })
        // テーマを取得
        this.$store.dispatch(colorThemeActions.INITIALIZE)
      } catch (e) {
        const message = 'IDもしくはパスワードが違います'
        this.$store.dispatch(snackbarActions.SHOW_SNACKBAR, {
          type: snackbarType.ERROR,
          message,
        })
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  width: 400px;
}

.notation {
  font-size: 12px;
  margin: 20px 0;
  text-align: left;
}
</style>
